import React, { Component } from 'react'
import styles from './Create.css'

class Subscribe extends Component {
  render () {
    return (
      <div className={`${styles['splash-page']} ${styles['gray-backgrond']}`}>
        <div className='splash-box'>
          <div className={styles['splash-content']}>
            <div id={styles.create}>
              <h3 style={{color: '#000000'}} className='text-center bottom40 font-weight-300'>
                Subscribe & Start Your Loyalty Program
              </h3>
              <div id={styles.subscribe}>
                <p style={{marginBottom: '25px'}} className='text-center'>
                  <img className='img-circle' src={require('assets/images/ic-loyalty.png')} />
                </p>

                <h4 className={`text-center ${styles['title']}`}>
                  Loyalty Program Feature
                </h4>

                <p className={`text-center ${styles['body-content']}`}>
                  Earn your customer's loyalty by giving them rewards<br />
                  to keep them coming back. Start your loyalty<br />
                  program now!
                </p>

                <div>
                  <div className={`${styles['pricing-title']}`}>
                    Pricing
                  </div>
                  <div className={`${styles['pricing-body']}`}>
                    <span className='pull-left'>Loyalty Program</span>
                    <span className='pull-right'>
                      <span className={`${styles['original-price']}`}>Rp 250.000/mo</span><span> FREE</span>
                    </span>
                  </div>
                </div>

                <button onClick={this._onClickStartTrial}
                  className={`btn btn-primary btn-block ${styles['start-trial-button']}`}
                >
                  Start free trial
                </button>
                <div className={styles['free-trial-footer']}>Your free trial is due on {this.props.subscriptionExpiredDate}</div>
              </div>
            </div>
          </div>
        </div>
      </div>
    )
  }

  _onClickStartTrial = (e) => {
    e.stopPropagation()
    this.props.createLoyalty()
  }
}

export default Subscribe



// WEBPACK FOOTER //
// ./app/pages/Customers/Loyalty/Create/Subscribe.js